import React, { useEffect, useState } from "react";
import { Popup, Icon, TextArea } from 'witmeg-ui-system';
import "./OfferModal.scss"
import close from "../../../../assets/close.svg"
import { useDispatch, useSelector } from "react-redux";
import { getCurrencyFormat, getLocalStorageData, LOCAL_STORAGE_ITEMS_NAMES } from "../../../../../../../utilities/helper";
import { v4 as uuidv4 } from 'uuid';
import _ from 'lodash';
import OfferDropdown from "./OfferDropdown";
import { setSelectedOffer } from "../../../../../../../../../redux/companyDataSlice";
import { fetchAllRestaurantMenuData, setOrderData } from "../../../../../../../../../redux/resturantWidgetSlice";
import { addToCart, getCartItemsToCartV3 } from "../../../../../RestaurantWidget/utilities/api/restaurantsService";
import tick from "../../../../assets/green-tick.svg"
import { Checkbox } from "antd";
import tickBalck from "../../../../assets/tick-black.svg"
import arrow from "../../../../assets/arrow-black.svg"

const OfferModal = ({ visibility, setIsOrderSuccess }) => {
    const dispatch = useDispatch()
    const [item, setItem] = useState(localStorage.getItem("ECOM_OFF_SL") ? JSON.parse(localStorage.getItem("ECOM_OFF_SL")) : null);

    const [quantities, setQuantities] = useState(localStorage.getItem("OFF_QT") ? JSON.parse(localStorage.getItem("OFF_QT")) : []);
    const [comments, setComments] = useState("");
    const [isLoading, setIsLoading] = useState(false)
    const [cartDetails, setCartDetails] = useState({});
    const [modRequired, setModRequired] = useState([])
    const [isOpen, setIsOpen] = useState([]);

    const { selectedOffer } = useSelector((state) => state.companyData);
    const { companyDetails } = useSelector((state) => state.companyData);
    const {
        menuData: {
            storage: { data }
        },
        currency,
        selectedOrderType
    } = useSelector((state) => state.resturantData);
    const currencyFormat = getCurrencyFormat(currency);
    const getItemPriceForCart = (option, quantity) => {
        const createPriceObj = (price, quantity) => ({
            Amount: price * quantity,
            FormattedText: currencyFormat((price * quantity) / 100),
            FormattedAmount: Number(((price * quantity) / 100).toFixed(2))
        });

        const getPriceData = (price, quantity) => ({
            Delivery: createPriceObj(price?.DeliveryPrice || 0, quantity),
            TakeAway: createPriceObj(price?.PickupPrice || 0, quantity),
            DineIn: createPriceObj(price?.TablePrice || 0, quantity),
            CurrencyCode: currency
        });

        const basePrice = getPriceData(option?.Price || {}, 1);
        const totalPrice = getPriceData(option?.Price || {}, quantity);
        return {
            BaseUnitPrice: basePrice,
            BaseTotalPrice: quantity > 1 ? totalPrice : basePrice
        };
    };
    const getOrderType = () => {
        let type;
        switch (selectedOrderType) {
            case "delivery":
                type = "DELIVERY_BY_REWARDCONSUMER";
                break;
            case "table":
                type = "DINE_IN";
                break;
            case "collection":
                type = "TAKE_AWAY";
                break;
            default:
                type = "DELIVERY_BY_REWARDCONSUMER";
                break;
        }
        return type
    }
    useEffect(() => {
        if (data && data.Items) {
            if (selectedOffer !== "") {
                const selectedOfferID = selectedOffer?.split("/")[0]
                const selectedItem = _.find(data.Items, { MenuItemID: selectedOfferID })
                const paramID = selectedOffer?.split("/")[1]
                if (selectedItem) {
                    setModRequired(findReqIDs(selectedItem))
                    let commentValue = paramID !== "new" ? JSON.parse(localStorage.getItem("OFF_QT"))[0]?.CustomerRequests?.SpecialInstructions && JSON.parse(localStorage.getItem("OFF_QT"))[0]?.CustomerRequests?.SpecialInstructions : ""
                    setComments(commentValue)
                    let newQuantityValue = localStorage.getItem("OFF_QT") ? JSON.parse(localStorage.getItem("OFF_QT"))[0]?.Quantity?.Amount : 1
                    let cartObject = {
                        "CartItemID": selectedItem?.MenuItemID,
                        "Title": selectedItem?.Title?.en,
                        "CustomerID": localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_USER_ID),
                        "Quantity": {
                            "Unit": "pcs",
                            "Amount": newQuantityValue
                        },
                        "DefaultQuantity": {
                            "Amount": 1,
                            "Unit": "pcs"
                        },
                        "CustomerRequests": {
                            "Allergy": {
                                "Allergens": [],
                                "Instructions": ""
                            },
                            "SpecialInstructions": comments
                        },
                        SelectedModifierGroups: [],
                        ValueID: localStorage.getItem("OFF_QT") ? JSON.parse(localStorage.getItem("OFF_QT"))[0]?.ValueID : uuidv4(),
                        ID: paramID !== "new" ? paramID : "",
                        ModifierGroupRules: selectedItem?.ModifierGroupRules,
                        Image: selectedItem?.ImageURL,
                        PriceInfo: getItemPriceForCart(selectedItem?.PriceInfo, newQuantityValue),
                        MetaData: {
                            IsDealProduct: true
                        }

                    }

                    let newQuantity = localStorage.getItem("OFF_QT") ? JSON.parse(localStorage.getItem("OFF_QT")) : [cartObject]
                    let newItem = { ...selectedItem, Quantity: newQuantityValue, SelectedModifierGroups: [], ValueID: newQuantity ? newQuantity[0]?.ValueID || uuidv4() : uuidv4() }
                    setItem(newItem);
                    localStorage.setItem("ECOM_OFF_SL", JSON.stringify(newItem))
                    if (JSON.parse(localStorage.getItem("OFF_QT"))) {

                        let quantityStorage = JSON.parse(localStorage.getItem("OFF_QT"))
                        let value = [{
                            ...quantityStorage[0], ModifierGroupRules: selectedItem.ModifierGroupRules
                        }]
                        setQuantities(value)
                        localStorage.setItem("OFF_QT", JSON.stringify(value))

                    } else {

                        setQuantities(newQuantity)
                        localStorage.setItem("OFF_QT", JSON.stringify(newQuantity))

                    }

                }
            }
        }
    }, [data, selectedOffer])
    useEffect(() => {
        const fetchData = async () => {
            const val = await getLocalStorageData(LOCAL_STORAGE_ITEMS_NAMES.ECOM_CART_DATA);
            const userDetails = localStorage.getItem('fullUserDetails')
            let parsedUserDetails = JSON.parse(localStorage.getItem('fullUserDetails'))
            let customer = {
                ID: localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_USER_ID),
                Name: {
                    DisplayName: userDetails ? parsedUserDetails.UserName : "",
                    FirstName: userDetails ? parsedUserDetails.FirstName : "",
                    LastName: userDetails ? parsedUserDetails.LastName : "",
                },
                Email: userDetails ? parsedUserDetails.Email : "",
                IsPrimaryCustomer: true

            }
            let cart = {
                "OrderID": localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_CART_ORDER_ID) ? localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_CART_ORDER_ID) : '',
                "StoreID": val?.cloudLocationID,
                "ConsumerID": localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_USER_ID),
                "OrderingPlatformType": "RETAILPACX",
                "CountryISOCode": "GB",
                "OrganizationID": val?.organizationID,
                "CloudLocationID": val?.cloudLocationID,
                "Name": companyDetails.shopName,
                "OrderFullFilmentType": getOrderType(),
                "Customers": [customer]
            }
            setCartDetails(cart)
            dispatch(fetchAllRestaurantMenuData({
                CloudLocationID: val?.cloudLocationID,
                OrganizationID: val?.organizationID,
                UserID: localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_USER_ID),
                Type: "MENU"
            }));
        };
        fetchData();
    }, [dispatch]);
    const updatePrice = (priceInfo, qty) => {
        let totalsVal = {
            "Delivery": {
                "Amount": priceInfo.BaseUnitPrice.Delivery.Amount * qty,
                "FormattedText": currencyFormat((priceInfo.BaseUnitPrice.Delivery.Amount * qty) / 100),
                "FormattedAmount": Number(((priceInfo.BaseUnitPrice.Delivery.Amount * qty) / 100).toFixed(2))
            },
            "TakeAway": {
                "Amount": priceInfo.BaseUnitPrice.TakeAway.Amount * qty,
                "FormattedText": currencyFormat((priceInfo.BaseUnitPrice.TakeAway.Amount * qty) / 100),
                "FormattedAmount": Number(((priceInfo.BaseUnitPrice.TakeAway.Amount * qty) / 100).toFixed(2))
            },
            "DineIn": {
                "Amount": priceInfo.BaseUnitPrice.DineIn.Amount * qty,
                "FormattedText": currencyFormat((priceInfo.BaseUnitPrice.DineIn.Amount * qty) / 100),
                "FormattedAmount": Number(((priceInfo.BaseUnitPrice.DineIn.Amount * qty) / 100).toFixed(2))

            },
            "CurrencyCode": "GBP"
        }
        let price = { ...priceInfo, BaseTotalPrice: totalsVal }
        return price
    }

    const getOptionPriceForCart = (overrides, Id, quantity) => {
        const option = _.find(overrides, { ContextValue: Id });
        const createPriceObj = (price, quantity) => ({
            Amount: price * quantity,
            FormattedText: currencyFormat((price * quantity) / 100),
            FormattedAmount: Number(((price * quantity) / 100).toFixed(2))
        });

        const getPriceData = (price, quantity) => ({
            Delivery: createPriceObj(price?.DeliveryPrice || 0, quantity),
            TakeAway: createPriceObj(price?.PickupPrice || 0, quantity),
            DineIn: createPriceObj(price?.TablePrice || 0, quantity),
            CurrencyCode: currency
        });

        const basePrice = getPriceData(option?.Price || {}, 1);
        const totalPrice = getPriceData(option?.Price || {}, quantity);

        return {
            BaseUnitPrice: basePrice,
            BaseTotalPrice: quantity > 1 ? totalPrice : basePrice
        };
    };
    const updateParentQuantities = async (prev = [], optionValue, modifierVal, parent) => {
        const updatedQuantities = JSON.parse(JSON.stringify(prev || []));

        let option = {
            CartItemID: optionValue.MenuItemID ? optionValue.MenuItemID : optionValue.CartItemID,
            Title: optionValue?.Title?.en ? optionValue?.Title.en : optionValue?.Title,
            ValueID: optionValue.ValueID,
            ParentID: optionValue.ParentID,
            Quantity: { Unit: "pcs", Amount: optionValue.Quantity ? optionValue.Quantity.Amount : 1 },
            SelectedModifierGroups: [],
            ModifierGroupRules: optionValue.ModifierGroupRules,
            PriceInfo:

                getOptionPriceForCart(optionValue?.PriceInfo?.Overrides, modifierVal.ModifierGroupID, optionValue.Quantity ? optionValue.Quantity.Amount : 1)
            ,
            MetaData: null
        };

        if (!option) return updatedQuantities;

        const updateRecursive = async (item, modifier, parentValue) => {
            const sameParent = item?.ModifierGroupRules?.IDs?.findIndex(id => id === modifier.ModifierGroupID);
            if (sameParent !== -1) {
                if (item.SelectedModifierGroups.length > 0) {
                    const parentIndex = item.SelectedModifierGroups.findIndex(it => it.ID === modifier.ModifierGroupID);
                    if (parentIndex !== -1) {
                        const itemValue = item.SelectedModifierGroups[parentIndex];
                        const optionIndex = itemValue.SelectedItems.findIndex(o => o.CartItemID === option.CartItemID);

                        if (item.ValueID === option.ParentID) {
                            if (optionIndex !== -1) {
                                itemValue.SelectedItems[optionIndex].Quantity.Amount += 1;
                                itemValue.SelectedItems[optionIndex].PriceInfo = updatePrice(
                                    itemValue.SelectedItems[optionIndex].PriceInfo,
                                    itemValue.SelectedItems[optionIndex].Quantity.Amount
                                );

                            } else {
                                itemValue.SelectedItems.push({ ...option, Quantity: { Unit: "pcs", Amount: 1 } });
                            }
                            return;
                        }

                        for (let mod of item.SelectedModifierGroups) {
                            for (let childMod of mod.SelectedItems) {
                                await updateRecursive(childMod, modifier, parentValue);
                            }
                        }
                    } else {
                        if (item.ValueID === option.ParentID) {
                            item.SelectedModifierGroups.push({
                                SelectedItems: [{ ...option, Quantity: { Unit: "pcs", Amount: 1 } }],
                                ID: modifier.ModifierGroupID,
                                Title: modifier.Title.en,
                                ModifierOptions: modifier.ModifierOptions,
                                QuantityConstraintsRules: modifier.QuantityConstraintsRules,
                                ParentID: modifier.ParentID || option.ParentID
                            });
                            return;
                        }
                        for (let mod of item.SelectedModifierGroups) {
                            for (let childMod of mod.SelectedItems) {
                                await updateRecursive(childMod, modifier, parentValue);
                            }
                        }
                    }
                } else {
                    if (item.ValueID === option.ParentID) {
                        item.SelectedModifierGroups.push({
                            SelectedItems: [{ ...option, Quantity: { Unit: "pcs", Amount: 1 } }],
                            ID: modifier.ModifierGroupID,
                            Title: modifier.Title.en,
                            ModifierOptions: modifier.ModifierOptions,
                            QuantityConstraintsRules: modifier.QuantityConstraintsRules,
                            ParentID: modifier.ParentID || option.ParentID
                        });
                    }
                }
            } else {
                for (let mod of item.SelectedModifierGroups) {
                    for (let childMod of mod.SelectedItems) {
                        await updateRecursive(childMod, modifier, parentValue);
                    }
                }
            }
        };

        await updateRecursive(updatedQuantities[0], modifierVal, parent);
        return updatedQuantities;
    };
    const addQtyOfModifiers = async (option, modifier, parent) => {
        try {
            const updated = await updateParentQuantities(quantities, option, modifier, parent);
            setQuantities(updated);
            localStorage.setItem("OFF_QT", JSON.stringify(updated))

        } catch (error) {
            console.error('Error updating quantities:', error);
        }
    };
    const reduceParentQuantities = (prev = [], optionValue, modifierVal, parent) => {
        return new Promise((resolve, reject) => {
            const updatedQuantities = JSON.parse(JSON.stringify(prev || []));
            let option = {
                CartItemID: optionValue.MenuItemID ? optionValue.MenuItemID : optionValue.CartItemID,
                Title: optionValue?.Title?.en ? optionValue?.Title.en : optionValue?.Title,
                ValueID: optionValue.ValueID,
                ParentID: optionValue.ParentID,
                Quantity:
                    { Unit: "pcs", Amount: optionValue.Quantity ? optionValue.Quantity.Amount : 1 },
                SelectedModifierGroups: [],
                ModifierGroupRules: optionValue.ModifierGroupRules,
                PriceInfo:
                    getOptionPriceForCart(optionValue?.PriceInfo?.Overrides, modifierVal.ModifierGroupID, optionValue.Quantity ? optionValue.Quantity.Amount : 1),
                MetaData: null

            };

            if (!option) {
                return resolve(updatedQuantities);
            }

            const reduceRecursive = (item, modifier, parentValue) => {
                return new Promise((resolveRecursive, rejectRecursive) => {
                    const sameParent = item?.ModifierGroupRules?.IDs?.findIndex(id => id === modifier.ModifierGroupID);
                    if (sameParent !== -1) {
                        if (item.SelectedModifierGroups.length > 0) {
                            const parentIndex = item.SelectedModifierGroups.findIndex(it => it.ID === modifier.ModifierGroupID);
                            if (parentIndex !== -1) {
                                const itemValue = item.SelectedModifierGroups[parentIndex];
                                const optionIndex = itemValue.SelectedItems.findIndex(o => o.CartItemID === option.CartItemID);

                                if (item.ValueID === option.ParentID) {
                                    if (optionIndex !== -1) {
                                        if (itemValue.SelectedItems[optionIndex].Quantity.Amount > 1) {
                                            itemValue.SelectedItems[optionIndex].Quantity.Amount -= 1;
                                            itemValue.SelectedItems[optionIndex].PriceInfo = updatePrice(itemValue.SelectedItems[optionIndex].PriceInfo, itemValue.SelectedItems[optionIndex].Quantity.Amount)


                                            resolveRecursive();
                                        } else {
                                            itemValue.SelectedItems.splice(optionIndex, 1);
                                            resolveRecursive();
                                        }
                                    } else {
                                        resolveRecursive();
                                    }
                                } else {
                                    for (let mod of item.SelectedModifierGroups) {
                                        for (let childMod of mod.SelectedItems) {
                                            reduceRecursive(childMod, modifier, parentValue)
                                                .then(() => resolve(updatedQuantities))
                                                .catch(reject);
                                        }
                                    }
                                }
                            } else {
                                if (item.ValueID === option.ParentID) {
                                    resolveRecursive();
                                }
                                else {
                                    for (let mod of item.SelectedModifierGroups) {
                                        for (let childMod of mod.SelectedItems) {
                                            reduceRecursive(childMod, modifier, parentValue)
                                                .then(() => resolve(updatedQuantities))
                                                .catch(reject);
                                        }
                                    }
                                }
                            }
                        } else {
                            if (item.ValueID === option.ParentID) {
                                resolveRecursive();
                            }
                        }
                    } else {
                        for (let mod of item.SelectedModifierGroups) {
                            for (let childMod of mod.SelectedItems) {
                                reduceRecursive(childMod, modifier, parentValue)
                                    .then(() => resolve(updatedQuantities))
                                    .catch(reject);
                            }
                        }
                    }
                });
            };

            reduceRecursive(updatedQuantities[0], modifierVal, parent)
                .then(() => resolve(updatedQuantities))
                .catch(reject);
        });
    };
    const handleCheckbox = (option, parent, modVal, modifier) => {
        if (!option) return "";
        let ID = option.MenuItemID ? option.MenuItemID : option.CartItemID
        let obj = _.find(modVal?.SelectedItems, { CartItemID: ID });
        if (obj && obj.Quantity.Amount > 0) {
            reduceQtyOfModifiers(option, modifier, parent)
        } else {
            addQtyOfModifiers(option, modifier, parent)
        }
    }
    const getThePriceItem = (overrides, Id, quantity) => {
        let price = getOptionPriceForCart(overrides, Id, quantity).BaseTotalPrice
        let priceValue;
        switch (selectedOrderType) {
            case "delivery":
                priceValue = price.Delivery.FormattedText;
                break;
            case "table":
                priceValue = price.DineIn.FormattedText;
                break;
            case "collection":
                priceValue = price.TakeAway.FormattedText;
                break;
            default:
                priceValue = price.Delivery.FormattedText;
                break;
        }

        return priceValue;
    };
    const reduceQtyOfModifiers = (option, modifier, parent) => {
        return new Promise(async (resolve) => {
            const updated = await reduceParentQuantities(quantities, option, modifier, parent);
            setQuantities(updated);
            localStorage.setItem("OFF_QT", JSON.stringify(updated))
            resolve(true)
        })
    };
    const getPriceSelectedOption = (selectedItem) => {
        let price = selectedItem.PriceInfo.BaseTotalPrice
        let priceValue;
        switch (selectedOrderType) {
            case "delivery":
                priceValue = price.Delivery.FormattedText;
                break;
            case "table":
                priceValue = price.DineIn.FormattedText;
                break;
            case "collection":
                priceValue = price.TakeAway.FormattedText;
                break;
            default:
                priceValue = price.Delivery.FormattedText;
                break;
        }
        return priceValue;
    }
    const getOptionPrice = (overrides, Id, quantity) => {
        let option = _.find(overrides, { ContextValue: Id })
        if (option) {
            return getThePriceItem(overrides, Id, quantity)
        } else {
            return "£0.00"
        }

    }
    const getModifierType = (rules) => {
        if (rules?.MinPermitted === 1 && rules?.MaxPermitted === 1 && (rules?.IsMinPermittedOptional || !rules?.IsMinPermittedOptional) && rules?.MaxPermittedUnique === 0 && rules?.MinPermittedUnique === 0) {
            return "RADIO"
        }
        if (rules?.MinPermitted >= 0 && rules?.MaxPermitted >= 1 && rules?.MaxPermittedUnique === 1 && rules?.MinPermittedUnique === 1 && rules?.IsMinPermittedOptional) {
            return "CHECK_BOX"
        }
        if (rules?.MinPermitted >= 0 && rules?.MaxPermitted >= rules?.MinPermitted && rules?.MaxPermittedUnique === 1 && rules?.MinPermittedUnique === 1 && !rules?.IsMinPermittedOptional) {
            return "CHECK_BOX"
        }
        if (rules?.MinPermitted >= 0 && rules?.MaxPermitted >= rules?.MinPermitted && (rules?.IsMinPermittedOptional || !rules?.IsMinPermittedOptional)) {
            return "CONTROLLER"
        }
        if (rules?.MinPermitted >= 0 && rules?.MaxPermitted >= rules?.MinPermitted && rules?.MaxPermittedUnique > rules?.MinPermittedUnique && rules?.MinPermittedUnique >= 0) {
            return "CONTROLLER"
        }
        if (rules?.MinPermitted > 0 && rules?.MaxPermitted >= rules?.MinPermitted && rules?.MaxPermittedUnique > rules?.MinPermittedUnique && rules?.MinPermittedUnique > 0 && !rules?.IsMinPermittedOptional) {
            return "CONTROLLER"
        }
    }
    const toggleModifierGroup = (id) => {
        setIsOpen((prevIsOpen) => {
            if (prevIsOpen.includes(id)) {
                return prevIsOpen.filter((groupId) => groupId !== id);
            } else {
                return [...prevIsOpen, id];
            }
        });
    };
    const getModifiers = (modifier, modVal) => {
        console.log(modVal?.SelectedItems[0], "Asd")
        if (!modifier) return null;
        let rule = getRule(modifier?.QuantityConstraintsRules?.Quantity)
        const parent = quantities[0]
        const options = modifier?.ModifierOptions?.map((optionItem, key) => {
            const optionValue = _.find(data.Items, { MenuItemID: optionItem.Id });
            if (!optionValue) return null;
            const newOption = {
                ...optionValue,
                ParentID: parent?.ValueID,
                ValueID: uuidv4(),
                SelectedModifierGroups: []
            };
            const existingOption = _.find(modVal?.SelectedItems, { CartItemID: optionValue.MenuItemID });

            return existingOption || newOption;
        });
        const quantityRules = modifier?.QuantityConstraintsRules?.Quantity;
        const minPermitted = quantityRules?.MinPermitted;
        let type = getModifierType(modifier?.QuantityConstraintsRules?.Quantity)
        return (
            <div className="modf-grp">
                <div className="modf-grp-header">


                    <div className="modf-grp-header-title">{modifier?.Title?.en?.replace(/\.+$/, '')}



                    </div>
                    {!modifier?.QuantityConstraintsRules?.Quantity?.IsMinPermittedOptional && (
                        (() => {

                            const minPermittedUnique = quantityRules?.MinPermittedUnique;
                            const selectedItems = modVal?.SelectedItems || [];

                            const meetsMinRequirement = selectedItems.length >= minPermitted;
                            const meetsUniqueRequirement = selectedItems.every(val => val.Quantity.Amount >= minPermittedUnique);

                            const meetmax = selectedItems.reduce((sum, item) => sum + item.Quantity.Amount, 0) >= quantityRules?.MaxPermitted
                            const isSelected = rule === "RULE_9" ? meetmax : rule === "RULE_8" ? (meetsMinRequirement && meetsUniqueRequirement) : meetsMinRequirement;
                            return (
                                <div className={`req ${isSelected ? "selected" : ""}`}>
                                    {isSelected && <img alt="Tick" src={tick} />}
                                    Required
                                </div>
                            );
                        })()
                    )}
                </div>
                <>
                    {rule === "RULE_3" && <div className="res" >*you can only choose up to {modifier?.QuantityConstraintsRules?.Quantity?.MaxPermitted} items</div>}
                    {rule === "RULE_4" && <div className="res" >*atleast you have to choose {modifier?.QuantityConstraintsRules?.Quantity?.MinPermitted} items and you can only choose up to {modifier?.QuantityConstraintsRules?.Quantity?.MaxPermitted} items</div>}
                    {rule === "RULE_5" && <div className="res">*atleast you have to choose {modifier?.QuantityConstraintsRules?.Quantity?.MinPermitted} items and you can only choose up to {modifier?.QuantityConstraintsRules?.Quantity?.MaxPermitted} items</div>}
                    {rule === "RULE_6" && <div className="res">*you can only choose up to {modifier?.QuantityConstraintsRules?.Quantity?.MaxPermitted} items</div>}
                    {rule === "RULE_7" && <div className="res">*you can only choose up to {modifier?.QuantityConstraintsRules?.Quantity?.MaxPermitted} items</div>}
                    {rule === "RULE_8" && <div className="res">*you must select at least {modifier?.QuantityConstraintsRules?.Quantity?.MinPermitted} item(s), choose no more than  {modifier?.QuantityConstraintsRules?.Quantity?.MaxPermitted} in total, and each item can be selected up to  {modifier?.QuantityConstraintsRules?.Quantity?.MaxPermittedUnique} times.</div>}</>
                {rule === "RULE_9" && <div className="res">*you can only choose up to {modifier?.QuantityConstraintsRules?.Quantity?.MaxPermitted} items</div>}

                {

                    type === "RADIO" ?
                        <OfferDropdown
                            options={options}
                            onSelect={async (opt) => {
                                const selectedOption = opt;
                                if (!selectedOption) return;
                                const selectedItem = _.find(data.Items, { MenuItemID: selectedOption.Id });
                                if (modVal) {
                                    let selectedModifierObj = _.find(modVal.SelectedItems, { CartItemID: selectedItem?.MenuItemID });
                                    if (!selectedModifierObj || selectedModifierObj.Quantity.Amount === 0) {
                                        addQtyOfModifiers(selectedOption, modifier, parent);
                                    }

                                    const optionIndex = modVal.SelectedItems.findIndex(o => o.CartItemID === selectedItem?.MenuItemID);

                                    if (optionIndex === -1) {
                                        modVal.SelectedItems.map(async (modifiers) => {
                                            const object = modifier?.ModifierOptions?.find(options =>
                                                options.Id === modifiers.CartItemID
                                            );
                                            const modIndex = modVal.SelectedItems.findIndex(o => o.CartItemID === modifiers.MenuItemID);
                                            if (object) {
                                                modVal.SelectedItems.splice(modIndex, 1);
                                                return await reduceQtyOfModifiers(object, modifier, parent);
                                            }
                                        });
                                        if (modVal.SelectedItems.length === 0) {
                                            addQtyOfModifiers(selectedOption, modifier, parent);
                                        }
                                    } else {
                                        await reduceQtyOfModifiers(selectedOption, modifier, parent);
                                    }
                                } else {
                                    addQtyOfModifiers(selectedOption, modifier, parent);

                                }
                            }}
                            selectedItem={modVal ? modVal?.SelectedItems?.length > 0 ? modVal?.SelectedItems[0] : null : null}
                            modifier={modifier}
                        />
                        :
                        isOpen.includes(modifier.ModifierGroupID) ? <div className="modifier-option-container">{modifier?.ModifierOptions?.map((options) => {
                            const optionValue = _.find(data.Items, { MenuItemID: options.Id });
                            const newOption = { ...optionValue, ParentID: parent.ValueID, ValueID: uuidv4(), SelectedModifierGroups: [] }
                            let obj = _.find(modVal?.SelectedItems, { CartItemID: optionValue.MenuItemID });
                            const selectedItem = _.find(data.Items, { MenuItemID: optionValue.MenuItemID });
                            let newObj = { ...obj, ModifierGroupRules: selectedItem.ModifierGroupRules }
                            let option = obj ? newObj : newOption
                            let isLimited = (modVal?.
                                SelectedItems.reduce((sum, item) => sum + item.Quantity.Amount, 0) || 0) < modifier?.QuantityConstraintsRules?.Quantity?.MaxPermitted
                            if (!option) return null;
                            return (
                                <div className="modifier-item" key={options.Id}>
                                    {type === "CHECK_BOX" ?
                                        <div className="option-name">

                                            <Checkbox style={{ marginTop: "-6px" }}
                                                onChange={() => {

                                                    if (rule === "RULE_4" || rule === "RULE_3") {
                                                        if ((modVal?.
                                                            SelectedItems.reduce((sum, item) => sum + item.Quantity.Amount, 0) || 0) <
                                                            modifier.QuantityConstraintsRules.Quantity.MaxPermitted) {
                                                            handleCheckbox(option, parent, modVal, modifier)
                                                        } else {
                                                            if (obj?.Quantity.Amount && obj?.Quantity.Amount > 0) {
                                                                handleCheckbox(option, parent, modVal, modifier)
                                                            }
                                                        }
                                                    } else {
                                                        handleCheckbox(option, parent, modVal, modifier)

                                                    }

                                                }}
                                                checked={obj?.Quantity.Amount && obj?.Quantity.Amount > 0 ? true : false} />

                                            <div className="item-name"> {option.Title.en ? option.Title.en.replace(/\.+$/, '') : option.Title.replace(/\.+$/, '')}</div>
                                            <div className="price-val">({obj ? getPriceSelectedOption(obj) : getOptionPrice(option.PriceInfo.Overrides, modifier.ModifierGroupID, obj?.Quantity.Amount || 1)})</div>

                                        </div>
                                        : type === "CONTROLLER" ? (
                                            <div className="option-name">

                                                <div className="qlt-option">

                                                    <div className={`icon-cont ${(obj?.Quantity.Amount || 0) === 0 ? "disabled" : ""}`} onClick={() => reduceQtyOfModifiers(option, modifier, parent)}>
                                                        <Icon name="minus" className="icon" />
                                                    </div>
                                                    <div className="qty-cont">
                                                        {obj?.Quantity.Amount || 0}
                                                    </div>
                                                    <div className={`icon-cont ${!isLimited ? "disabled" : rule === "RULE_8" ? (obj?.Quantity.Amount || 0) >= modifier.QuantityConstraintsRules.Quantity.MaxPermittedUnique ? "disabled" : "" : ""}`} onClick={() => {
                                                        if (isLimited) {

                                                            if (rule === "RULE_8") {
                                                                if ((obj?.Quantity.Amount || 0) < modifier.QuantityConstraintsRules.Quantity.MaxPermittedUnique) {
                                                                    addQtyOfModifiers(option, modifier, parent)
                                                                }
                                                            } else {
                                                                if ((obj?.Quantity.Amount || 0) < modifier.QuantityConstraintsRules.Quantity.MaxPermitted) {
                                                                    addQtyOfModifiers(option, modifier, parent)

                                                                }

                                                            }


                                                        }
                                                    }}>
                                                        <Icon name="plus" className="icon" />
                                                    </div></div>
                                                <div className="item-name"> {option.Title.en ? option.Title.en.replace(/\.+$/, '') : option.Title.replace(/\.+$/, '')}</div>
                                                <div className="price-val">({obj ? getPriceSelectedOption(obj) : getOptionPrice(option.PriceInfo.Overrides, modifier.ModifierGroupID, obj?.Quantity.Amount || 1)})</div>

                                            </div>
                                        ) : null}</div>
                            )

                        })}
                            <div className="hide-opt" onClick={() => toggleModifierGroup(modifier.ModifierGroupID)}>Hide Options</div>
                        </div> : <div className="select-opt" onClick={() => toggleModifierGroup(modifier.ModifierGroupID)}>Select option(s)
                            <img alt="" className="arrow" src={arrow} /></div>

                }
            </div>

        )
    }


    const increaseQty = () => {
        let newItem = { ...item, Quantity: item.Quantity ? item.Quantity + 1 : 1 }
        setItem(newItem)
        localStorage.setItem("ECOM_OFF_SL", JSON.stringify(newItem))
        let update = {
            ...quantities[0], Quantity: {
                ...quantities[0].Quantity, Amount: newItem.Quantity,

            }, PriceInfo: getItemPriceForCart(newItem.PriceInfo, newItem.Quantity)
        }
        setQuantities([update])
        localStorage.setItem("OFF_QT", JSON.stringify([update]))
    }
    const decreaseQty = () => {
        if (item.Quantity > 1) {
            let newItem = { ...item, Quantity: item.Quantity ? item.Quantity - 1 : 0 }
            setItem(newItem)
            localStorage.setItem("ECOM_OFF_SL", JSON.stringify(newItem))
            let update = {
                ...quantities[0], Quantity: {
                    ...quantities[0].Quantity, Amount: newItem.Quantity,
                },
                PriceInfo: getItemPriceForCart(newItem.PriceInfo, newItem.Quantity)
            }
            setQuantities([update])

            localStorage.setItem("OFF_QT", JSON.stringify([update]))
        }
    };
    const getType = () => {
        let type;
        switch (selectedOrderType) {
            case "delivery":
                type = "Delivery";
                break;
            case "table":
                type = "DineIn";
                break;
            case "collection":
                type = "TakeAway";
                break;
            default:
                type = "Delivery";
                break;
        }

        return type;
    };
    const calculateTotalPrice = () => {
        const cartItem = quantities[0]
        let type = getType()
        if (cartItem) {
            const calculateModifierPrice = (modifierGroups, type) => {
                let total = 0;

                modifierGroups.forEach(group => {
                    group.SelectedItems.forEach(item => {
                        total += (item.PriceInfo.BaseUnitPrice[type]?.Amount * (item?.Quantity?.Amount));
                        if (item.SelectedModifierGroups?.length) {
                            total += calculateModifierPrice(item.SelectedModifierGroups, type);
                        }
                    });
                });

                return total;
            };
            let totalPrice = (cartItem?.PriceInfo?.BaseUnitPrice[type]?.Amount || 0) * item?.Quantity;

            if (cartItem?.SelectedModifierGroups?.length) {
                totalPrice += calculateModifierPrice(cartItem?.SelectedModifierGroups, type) * item?.Quantity;
            }
            totalPrice = totalPrice

            return {
                Amount: totalPrice,
                FormattedText: `£${(totalPrice / 100).toFixed(2)}`,
                FormattedAmount: totalPrice / 100
            };
        }
    };
    const getRule = (rules) => {

        if (rules?.MinPermitted === 1 && rules?.MaxPermitted === 1 && !rules?.IsMinPermittedOptional && rules?.MaxPermittedUnique === 0 && rules?.MinPermittedUnique === 0) {
            return "RULE_1"
        }
        if (rules?.MinPermitted === 1 && rules?.MaxPermitted === 1 && rules?.IsMinPermittedOptional && rules?.MaxPermittedUnique === 0 && rules?.MinPermittedUnique === 0) {
            return "RULE_2"
        }
        if (rules?.MinPermitted >= 0 && rules?.MaxPermitted >= 1 && rules?.MaxPermittedUnique === 1 && rules?.MinPermittedUnique === 1 && rules?.IsMinPermittedOptional) {
            return "RULE_3"
        }
        if (rules?.MinPermitted >= 0 && rules?.MaxPermitted >= rules?.MinPermitted && rules?.MaxPermittedUnique === 1 && rules?.MinPermittedUnique === 1 && !rules?.IsMinPermittedOptional) {
            return "RULE_4"
        }
        if (rules?.MinPermitted > 0 && rules?.MaxPermitted >= rules?.MinPermitted && rules?.MaxPermittedUnique > rules?.MinPermittedUnique && rules?.MinPermittedUnique > 0) {
            return "RULE_9"
        }
        if (rules?.MinPermitted > 0 && rules?.MaxPermitted > rules?.MinPermitted && rules?.MaxPermittedUnique > rules?.MinPermittedUnique && rules?.MinPermittedUnique > 0 && !rules?.IsMinPermittedOptional) {
            return "RULE_8"
        }
        if (rules?.MinPermitted >= 0 && rules?.MaxPermitted >= rules?.MinPermitted && rules?.MaxPermittedUnique > rules?.MinPermittedUnique && rules?.MinPermittedUnique >= 0 && rules?.IsMinPermittedOptional) {
            return "RULE_7"
        }
        if (rules?.MinPermitted > 0 && rules?.MaxPermitted >= rules?.MinPermitted && !rules?.IsMinPermittedOptional) {
            return "RULE_5"
        }
        if (rules?.MinPermitted >= 0 && rules?.MaxPermitted >= rules?.MinPermitted && rules?.IsMinPermittedOptional) {
            return "RULE_6"
        }
    }
    const findReq = (item) => {
        // Recursive helper function
        const findInModifiers = (item, modifierGroups) => {
            if (!item?.ModifierGroupRules?.IDs || !Array.isArray(item?.ModifierGroupRules?.IDs)) {
                return false; // If no valid IDs exist, return false
            }

            return item.ModifierGroupRules.IDs.every(idVal => {
                const modifier = _.find(modifierGroups, { ModifierGroupID: idVal });
                if (!modifier) return false; // Ensure modifier exists

                const modifierWithID = { ...modifier, ParentID: quantities[0]?.ValueID };
                const newMod = quantities[0]?.SelectedModifierGroups && Array.isArray(quantities[0]?.SelectedModifierGroups)
                    ? _.find(quantities[0]?.SelectedModifierGroups, { ID: modifier?.ModifierGroupID })
                    : null;

                if (!modifierWithID?.QuantityConstraintsRules?.Quantity?.IsMinPermittedOptional) {
                    const quantityRules = modifierWithID?.QuantityConstraintsRules?.Quantity;
                    const minPermitted = quantityRules?.MinPermitted || 0;
                    const minPermittedUnique = quantityRules?.MinPermittedUnique || 0;
                    const selectedItems = newMod?.SelectedItems || [];

                    const meetsMinRequirement = selectedItems.length >= minPermitted;
                    const meetsUniqueRequirement = selectedItems.every(val => val.Quantity.Amount >= minPermittedUnique);
                    const rule = getRule(modifierWithID?.QuantityConstraintsRules?.Quantity);
                    const meetmax = selectedItems.reduce((sum, item) => sum + item.Quantity.Amount, 0) >= quantityRules?.MaxPermitted
                    const isSelected = rule === "RULE_9" ? meetmax : rule === "RULE_8"
                        ? (meetsMinRequirement && meetsUniqueRequirement)
                        : meetsMinRequirement;
                    if (!isSelected) {
                        return false; // If any item fails, return false
                    }
                }

                // Recursively check nested modifier groups
                if (newMod?.SelectedModifierGroups?.length > 0) {
                    return findInModifiers(
                        { ModifierGroupRules: { IDs: newMod.SelectedModifierGroups.map(mod => mod.ModifierGroupID) } },
                        modifierGroups
                    );
                }

                return true; // If all conditions pass
            });
        };

        return findInModifiers(item, data?.ModifierGroups);
    };
    const findReqIDs = (item) => {
        const failedIDs = [];

        const findInModifiers = (item, modifierGroups) => {
            if (!item?.ModifierGroupRules?.IDs || !Array.isArray(item?.ModifierGroupRules?.IDs)) {
                return;
            }

            item.ModifierGroupRules.IDs.forEach(idVal => {
                const modifier = _.find(modifierGroups, { ModifierGroupID: idVal });
                if (!modifier) {
                    failedIDs.push(modifier);
                    return;
                }

                const modifierWithID = { ...modifier, ParentID: quantities[0]?.ValueID };
                const newMod = quantities[0]?.SelectedModifierGroups && Array.isArray(quantities[0]?.SelectedModifierGroups)
                    ? _.find(quantities[0]?.SelectedModifierGroups, { ID: modifier?.ModifierGroupID })
                    : null;

                if (!modifierWithID?.QuantityConstraintsRules?.Quantity?.IsMinPermittedOptional) {
                    const quantityRules = modifierWithID?.QuantityConstraintsRules?.Quantity;
                    const minPermitted = quantityRules?.MinPermitted || 0;
                    const minPermittedUnique = quantityRules?.MinPermittedUnique || 0;
                    const selectedItems = newMod?.SelectedItems || [];

                    const meetsMinRequirement = selectedItems.length >= minPermitted;
                    const meetsUniqueRequirement = selectedItems.every(val => val.Quantity.Amount >= minPermittedUnique);
                    const rule = getRule(modifierWithID?.QuantityConstraintsRules?.Quantity);
                    const meetmax = selectedItems.reduce((sum, item) => sum + item.Quantity.Amount, 0) >= quantityRules?.MaxPermitted
                    const isSelected = rule === "RULE_9" ? meetmax : rule === "RULE_8"
                        ? (meetsMinRequirement && meetsUniqueRequirement)
                        : meetsMinRequirement;

                    if (!isSelected) {
                        failedIDs.push(modifier);
                    }
                }

                if (newMod?.SelectedModifierGroups?.length > 0) {
                    findInModifiers(
                        { ModifierGroupRules: { IDs: newMod.SelectedModifierGroups.map(mod => mod.ModifierGroupID) } },
                        modifierGroups
                    );
                }
            });
        };

        findInModifiers(item, data?.ModifierGroups);
        return failedIDs;
    };

    const updateQuantity = () => {
        if (!quantities[0]) return;

        const deepClone = obj => JSON.parse(JSON.stringify(obj));
        const parentItem = deepClone(quantities[0]);

        const updateSelectedItems = (selectedItems, multiplier) => {
            selectedItems.forEach(item => {
                let updatedAmount = item.Quantity.Amount * multiplier;
                item.Quantity.Amount = Number.isInteger(updatedAmount) ? updatedAmount : Math.round(updatedAmount);
                if (item.SelectedModifierGroups.length > 0) {
                    item.SelectedModifierGroups.forEach(group => {
                        updateSelectedItems(group.SelectedItems, multiplier);
                    });
                }
            });
        };

        parentItem.SelectedModifierGroups.forEach(group => {
            updateSelectedItems(group.SelectedItems, parentItem.Quantity.Amount);
        });
        return parentItem;
    };
    const handleAddToCart = async () => {
        setIsLoading(true)
        let data = {
            ...cartDetails, Cart: updateQuantity(),
            OrderID: localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_CART_ORDER_ID) ? localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_CART_ORDER_ID) : '',
            OrderType: "MENU"
        }
        await addToCart(data).then((response) => {
            if (response) {
                let customerID = localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_USER_ID);
                let cloud = JSON.parse(localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_DATA)).cloudLocationID
                getCartItemsToCartV3(customerID, cloud, "MENU").then((response) => {
                    if (response) {
                        setIsLoading(false)
                        dispatch(setOrderData(response))
                        setItem(null)
                        setQuantities([])
                        localStorage.removeItem("OFF_QT")
                        localStorage.removeItem("ECOM_OFF_SL")
                        dispatch(setSelectedOffer(""))
                        setIsOrderSuccess(true)
                    }
                })

            }
        }).catch(() => {
            setIsLoading(false)
        })
    }
    const updateSpecialInstructionForFirstItem = (newInstruction) => {
        setQuantities((prevCartItems) => {
            const updatedCartItems = [...prevCartItems];
            updatedCartItems[0] = {
                ...updatedCartItems[0],
                CustomerRequests: {
                    ...updatedCartItems[0].CustomerRequests,
                    SpecialInstructions: newInstruction
                }
            };

            return updatedCartItems;
        })
    }
    return (
        <Popup
            className='OfferModal'
            modalVisible={visibility}
            modalTitle=""
            mask={true}
            centered
            onCancel={() => {
            }}
            closable={false}>
            <div className="modal-inner">
                <div className="modal-inner-header-container">
                    <div className="modal-inner-header-wrapper">
                        <div className="modal-inner-title-text">
                            {item?.Title?.en}
                        </div>
                        <img className="close-icon" alt="" src={close}
                            onClick={() => {
                                setItem(null)
                                setQuantities([])
                                localStorage.removeItem("OFF_QT")
                                localStorage.removeItem("ECOM_OFF_SL")
                                dispatch(setSelectedOffer(""))

                            }} />
                    </div>
                </div>
                <div className="modal-inner-container">
                    <div className="offer-description">{item?.Description?.en}</div>
                    <div className="items-list">
                        {item?.ModifierGroupRules?.Groups?.map((group, key) => {
                            return (
                                <div className="single-offer-item" key={key}>
                                    <div className="group-header">{group?.GroupName?.en}<div className="group-des">({group?.Description?.en})</div></div>
                                    {group?.IDs.map((idVal) => {
                                        const modifier = _.find(data?.ModifierGroups, { ModifierGroupID: idVal });
                                        const newMod = quantities[0]?.SelectedModifierGroups && quantities[0]?.SelectedModifierGroups?.length > 0 ? _.find(quantities[0]?.SelectedModifierGroups, { ID: modifier?.ModifierGroupID }) : null
                                        const modifierWithID = { ...modifier, ParentID: quantities[0]?.ValueID }
                                        if (modifier) {

                                            return getModifiers(modifierWithID, newMod)
                                        }
                                    })}
                                </div>
                            )

                        })}
                    </div>
                    <div className="qty-wrapper">
                        <div className="qty-wrapper-header">Quantity</div>
                        <div className="quantity">

                            <div className="icon-cont" onClick={decreaseQty}> <Icon name="minus" className="icon" /></div>

                            <div className="qty-cont">
                                {item?.Quantity || 0}
                            </div>

                            <div className="icon-cont" onClick={increaseQty}>
                                <Icon name="plus" className="icon" />
                            </div>
                        </div>
                    </div>
                    <div className="comments-sec">
                        <div className="comments-title" >
                            Add Comments (Optional)
                        </div>
                        <TextArea
                            placeholder="Add any special requests (e.g., no cheese, sauce on the side). If you have any allergies, please mention them here."
                            value={comments}
                            onChange={(e) => {
                                setComments(e.target.value)
                                updateSpecialInstructionForFirstItem(e.target.value)
                            }}
                            className="text-area"
                        />
                    </div>
                    <div className="req-options-list">
                        <div className="req-options-list-header"><span>*</span>Required selections needed: Please choose all marked options to place your order.</div>

                        <div className="req-list">
                            {modRequired?.map((mod) => {
                                const include = findReqIDs(item)?.find((val) => val.ModifierGroupID === mod.ModifierGroupID)
                                return (<div className={`req-list-item ${!include ? "selected" : ""}`}>
                                    <img className="tick-ico" alt="" src={tickBalck} />{mod?.Title?.en}</div>)
                            })}
                        </div>
                    </div>
                    <div className="total-price-cont">
                        <div className="amount-text">Total</div>
                        <div className="amount-text">{calculateTotalPrice()?.FormattedText}</div>
                    </div>
                    <div className="btn-container-wrapper">
                        <div className="btn-add-cont"
                            style={{ backgroundColor: !findReq(item) ? "#e0e0e0" : "", cursor: !findReq(item) ? "default" : "pointer" }}
                            onClick={async () => {
                                if (findReq(item) && !isLoading) {
                                    handleAddToCart()
                                }



                            }}>
                            {isLoading && <div className="loader-btn" />}

                            {selectedOffer?.split("/")[1] !== "new" ? "Update Cart" :
                                "Add to Cart"} -      {calculateTotalPrice()?.FormattedText}
                        </div>
                    </div>
                </div>

            </div>
        </Popup>
    )
}
export default OfferModal